module.exports = __webpack_public_path__ + "static/img/bg_2_6.27a22a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_6.png
// module id = 0eCI
// module chunks = 3